export const modules = [
  { title: "Cómo funciona el sistema", text: "Entiende el modelo de productos digitales y la mentalidad necesaria para ejecutarlo." },
  { title: "Espionaje + creación de producto", text: "Aprende a detectar oportunidades en ADS PARO y convertirlas en productos digitales propios." },
  { title: "Creación de tu tienda", text: "Construye tu tienda y landing en Impultienda para transformar tu producto en una oferta lista para vender." },
  { title: "Meta Ads", text: "Crea tus anuncios, lanza tus campañas y aprende a llevar tráfico hacia tu oferta." },
  { title: "Optimización + escala", text: "Analiza tus resultados, encuentra lo que funciona y aprende a multiplicarlo." },
];

export const flowSteps = ["Espionaje", "Producto", "Tienda", "Anuncios", "Ventas", "Optimización", "Escala"];

export const transformation = [
  "seguir cuando las cosas no funcionaban.",
  "aprender de mis errores.",
  "tomar decisiones con datos.",
  "dejar de buscar la oportunidad perfecta.",
  "tener paciencia.",
  "volver a empezar.",
];

export const liveTopics = [
  "Qué hacer cuando empiezas a dudar.",
  "Qué hacer cuando gastas dinero y no vendes.",
  "Qué hacer cuando quieres abandonar.",
  "Cómo mantenerte enfocado.",
  "Cómo desarrollar disciplina.",
  "Cómo mantener la fe durante el proceso.",
];

export const outcomes = [
  "Sé encontrar una oportunidad.",
  "Sé crear un producto.",
  "Sé construir una oferta.",
  "Sé crear una tienda.",
  "Sé lanzar anuncios.",
  "Sé analizar mis números.",
  "Sé encontrar lo que funciona.",
  "Sé volver a hacerlo.",
];

export const notFor = ["Dinero rápido.", "Una fórmula mágica.", "Que alguien haga el trabajo por él.", "Resultados sin ejecutar."];
export const isFor = ["Aprender.", "Ejecutar.", "Equivocarse.", "Analizar.", "Volver a intentarlo.", "Construir algo propio."];

export const includes = [
  { icon: "platform", title: "Plataforma CLARIFY CORE", text: "Los 5 módulos completos del sistema." },
  { icon: "live", title: "Mentoría grupal semanal", text: "Una sesión en vivo cada semana contigo." },
  { icon: "community", title: "Comunidad privada", text: "Un espacio para compartir avances, preguntas y aprendizajes." },
  { icon: "mindset", title: "Mentalidad + Fe", text: "Trabajo en vivo sobre los obstáculos que aparecen mientras construyes." },
  { icon: "resources", title: "Recursos", text: "Plantillas, herramientas y recursos para ejecutar el sistema." },
] as const;

export const freedomMeanings = [
  "Para algunos significa tiempo.",
  "Para otros significa dinero.",
  "Para otros significa poder estar con su familia.",
  "Para otros significa trabajar desde cualquier lugar.",
];

export const salesFeed = [
  { product: "Guía digital · Plan Pro", amount: "$47.00", time: "hace 1 min" },
  { product: "Pack de plantillas", amount: "$27.00", time: "hace 3 min" },
  { product: "Guía digital · Plan Pro", amount: "$47.00", time: "hace 6 min" },
  { product: "Curso express", amount: "$67.00", time: "hace 9 min" },
  { product: "Pack de plantillas", amount: "$27.00", time: "hace 12 min" },
];
